import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { News } from './../../../classes/classes';
import { NewsService } from './../../../services/news.service';

@Component({
  selector: 'app-article-view',
  templateUrl: './article-view.component.html',
  styleUrls: ['./article-view.component.sass']
})

export class ArticleViewComponent implements OnInit {

  article: News;

  constructor(
    private _route: ActivatedRoute,
    private _service: NewsService) { }

  ngOnInit() {
    // get the news from the relative list
    if (this._service.get_all_news().find((n: News) => n.url == this._route.snapshot.url[1].path) != undefined)
      this.article = this._service.get_all_news().find((n: News) => n.url == this._route.snapshot.url[1].path)
    else if (this._service.get_pi_news().find((n: News) => n.url == this._route.snapshot.url[1].path) != undefined)
      this.article = this._service.get_pi_news().find((n: News) => n.url == this._route.snapshot.url[1].path)
    else if (this._service.get_europe_news().find((n: News) => n.url == this._route.snapshot.url[1].path) != undefined)
      this.article = this._service.get_europe_news().find((n: News) => n.url == this._route.snapshot.url[1].path)
  }

  public backFn(): void {
    history.back();
  }
}